import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import { BiSearch, BiPencil, BiCode, BiTestTube, BiRocket, BiSupport } from "react-icons/bi";

const SoftwareDevelopmentProcess = () => {
    const { t } = useTranslations();

    const processSteps = [
        {
            step: "01",
            title: t("softwareDevelopment_process_step1_title"),
            description: t("softwareDevelopment_process_step1_description"),
            icon: BiSearch,
            color: "#59bd65",
        },
        {
            step: "02",
            title: t("softwareDevelopment_process_step2_title"),
            description: t("softwareDevelopment_process_step2_description"),
            icon: BiPencil,
            color: "#4CAF50",
        },
        {
            step: "03",
            title: t("softwareDevelopment_process_step3_title"),
            description: t("softwareDevelopment_process_step3_description"),
            icon: BiCode,
            color: "#45a049",
        },
        {
            step: "04",
            title: t("softwareDevelopment_process_step4_title"),
            description: t("softwareDevelopment_process_step4_description"),
            icon: BiTestTube,
            color: "#388E3C",
        },
        {
            step: "05",
            title: t("softwareDevelopment_process_step5_title"),
            description: t("softwareDevelopment_process_step5_description"),
            icon: BiRocket,
            color: "#2E7D32",
        },
        {
            step: "06",
            title: t("softwareDevelopment_process_step6_title"),
            description: t("softwareDevelopment_process_step6_description"),
            icon: BiSupport,
            color: "#1B5E20",
        }
    ];

    return (
        <section className="ptb-100 sd-process">
            {/* Hintergrund-Dekoration */}
            <div className="sd-process__decoration sd-process__decoration--top-left"></div>
            <div className="sd-process__decoration sd-process__decoration--bottom-right"></div>

            <div className="container">
                <div className="section-title text-center sd-process__header">
                    <h2 className="sd-process__title">
                        {t("softwareDevelopment_process_title")}
                        <span className="sd-process__title-underline"></span>
                    </h2>
                    <p className="sd-process__description">
                        {t("softwareDevelopment_process_description")}
                    </p>
                </div>

                <div className="row">
                    {processSteps.map((step, index) => {
                        const IconComponent = step.icon;
                        return (
                            <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                                <div className="sd-process-card">
                                    {/* Schritt-Nummer */}
                                    <div
                                        className="sd-process-card__step-number"
                                        style={{
                                            background: `linear-gradient(135deg, ${step.color}, ${step.color}dd)`,
                                            boxShadow: `0 4px 15px ${step.color}40`
                                        }}
                                    >
                                        {step.step}
                                    </div>

                                    {/* Icon */}
                                    <div
                                        className="sd-process-card__icon"
                                        style={{
                                            background: `linear-gradient(135deg, ${step.color}, ${step.color}dd)`,
                                            boxShadow: `0 10px 30px ${step.color}30`
                                        }}
                                    >
                                        <IconComponent className="sd-process-card__icon-svg" />
                                    </div>

                                    {/* Titel */}
                                    <h3 className="sd-process-card__title">
                                        {step.title}
                                    </h3>

                                    {/* Beschreibung */}
                                    <p className="sd-process-card__description">
                                        {step.description}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default SoftwareDevelopmentProcess;
